// src/stone/icons/DollarShield2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DollarShield2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M20.947 8.52v22.96h-2V8.52z" }),
      /* @__PURE__ */ jsx("path", { d: "M18.983 10.754c2.377-.17 5.092.439 6.499 1.212l.876.481-.963 1.753-.877-.482c-1.02-.56-3.34-1.116-5.392-.97-1.018.074-1.844.312-2.389.697-.492.346-.808.842-.808 1.662 0 1.008.412 1.637 1.108 2.146.762.56 1.823.942 3.062 1.354l.257.086c1.102.365 2.34.776 3.305 1.398 1.112.716 1.975 1.787 1.975 3.429 0 1.45-.481 2.614-1.367 3.451-.859.812-2.004 1.228-3.185 1.405-2.348.352-5.195-.184-7.465-1.004l-.94-.339.678-1.881.94.34c2.1.757 4.592 1.191 6.49.906.942-.14 1.648-.445 2.108-.88.434-.41.741-1.022.741-1.998 0-.785-.35-1.292-1.058-1.748-.743-.479-1.748-.813-2.936-1.209l-.176-.058c-1.188-.396-2.555-.863-3.612-1.639-1.125-.825-1.925-2.016-1.925-3.759 0-1.477.638-2.58 1.656-3.297.963-.68 2.2-.97 3.398-1.056" }),
      /* @__PURE__ */ jsx("path", { d: "m20 .645 17.667 3.702v18.272c0 4.453-1.877 8.71-5.196 11.84-3.317 3.127-7.804 4.874-12.471 4.874s-9.154-1.747-12.471-4.875c-3.32-3.13-5.196-7.386-5.196-11.839V4.347zM4.333 5.971v16.648c0 3.883 1.636 7.62 4.568 10.384 2.934 2.767 6.926 4.33 11.099 4.33s8.165-1.563 11.099-4.33c2.932-2.765 4.568-6.501 4.568-10.384V5.971L20 2.688z" })
    ]
  }
);
var DollarShield2X_default = DollarShield2X;

export {
  DollarShield2X,
  DollarShield2X_default
};
